export const RESTAURANT_LIST_REQUEST='RESTAURANT_LIST_REQUEST'
export const RESTAURANT_LIST_SUCCESS="RESTAURANT_LIST_SUCCESS"
export const RESTAURANT_LIST_FAIL="RESTAURANT_LIST_FAIL"